import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from 'lodash';
import defaultAvt from '../assets/images/default-avatar.png';
import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import imageExists from 'image-exists';

export const apiCaller = (endpoint, method = 'GET', body) => {
	const _token = localStorage.getItem('_token');
	const headers = {
		'Content-Type' : 'application/json',
		Authorization  : `Bearer ${_token}`
	};
	return axios({
		method  : method,
		url     : `${process.env.REACT_APP_API_URL}${endpoint}`,
		data    : body,
		headers : headers
	});
};

// check status
export const checkStatusResponse = (error) => {
	if (error) {
		switch (error.status) {
			case 0:
				notifyToast('warning', 'Vui lòng kiểm tra lại mạng');
				break;
			case 400:
				notifyToast('error', error.data.message ? error.data.message : 'Có lỗi xảy ra');
				break;
			case 401:
				notifyToast('error', 'Phiên làm việc hết hạn. Vui lòng đăng nhập lại');
				localStorage.removeItem('_token');
				setTimeout(() => {
					return window.location.replace('/');
				}, 1500);
				break;
			case 403:
				notifyToast('error', 'Không có quyền');
				break;
			case 404:
				notifyToast('error', error.data.response ? error.data.response : error.data.message);
				break;
			case 500:
				notifyToast('error', error.data.message);
				break;
			default:
				return notifyToast('error', 'Có lỗi xảy ra');
		}
	} else {
		return notifyToast('error', 'Có lỗi xảy ra');
	}
};

export const notifyToast = (
	notifyType,
	notifyContent,
	position = 'top-center',
	hideProgressBar = false,
	autoClose = 1500
) => {
	switch (notifyType) {
		case 'success':
			return toast.success(notifyContent, {
				position,
				autoClose,
				hideProgressBar,
				closeOnClick    : true,
				pauseOnHover    : true,
				draggable       : false
			});

		case 'error':
			return toast.error(notifyContent, {
				position,
				autoClose,
				hideProgressBar,
				closeOnClick    : true,
				pauseOnHover    : true,
				draggable       : false
			});
		case 'info':
			return toast.info(notifyContent, {
				position,
				autoClose,
				hideProgressBar,
				closeOnClick    : true,
				pauseOnHover    : true,
				draggable       : false
			});
		case 'warning':
			return toast.warning(notifyContent, {
				position,
				autoClose,
				hideProgressBar,
				closeOnClick    : true,
				pauseOnHover    : true,
				draggable       : false
			});
		case 'dark':
			return toast.dark(notifyContent, {
				position,
				autoClose,
				hideProgressBar,
				closeOnClick    : true,
				pauseOnHover    : true,
				draggable       : false
			});
	}
};

export const formatDate = (date) => {
	return moment(date).format('DD/MM/YYYY');
};

export const withoutAccentsVietnamese = (str) => {
	str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
	str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
	str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
	str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
	str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
	str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
	str = str.replace(/đ/g, 'd');
	str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
	str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
	str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
	str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
	str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
	str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
	str = str.replace(/Đ/g, 'D');
	str = str.trim();
	return str;
};

export const convertStringToUrl = (str) => {
	str = str.toLowerCase();
	str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
	str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
	str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
	str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
	str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
	str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
	str = str.replace(/đ/g, 'd');
	str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
	str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
	str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
	str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
	str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
	str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
	str = str.replace(/Đ/g, 'D');
	str = str.replace(/ /g, '-');
	str = str.replace(/_/g, '-');
	str = str.trim();
	return str;
};

export const getIdCategories = (value) => {
	let result = null;
	const splitValue = value.split('-');
	return (result = parseInt(splitValue[splitValue.length - 1]));
};

export const fromBreadcrumbObjectToString = (o, delimiter) => {
	let label = [];
	o.breadCrumb = _.sortBy(o.breadCrumb, []);
	for (let p in o.breadCrumb) {
		label.push(o.breadCrumb[p]);
	}
	let label2 = label.join(delimiter);
	if (!label2) {
		label2 = o.name;
	} else {
		label2 = `${label2}${delimiter}${o.name}`;
	}
	label = label2;
	return label2;
};

export const shorten = (text, max) => {
	return text && text.length > max ? text.slice(0, max).split(' ').slice(0, -1).join(' ') + ' ...' : text;
};

export const img_facebook_default = 'https://ibb.co/TL7g258';
export const defaultSeoTitle = 'Tổng công ty chuyển phát nhanh bưu điện';
export const defaultMetaDescription = `Công ty giao nhận đầu tiên tại Việt Nam được thành lập
                     với sứ mệnh phục vụ nhu cầu vận chuyển chuyên nghiệp của
                      các đối tác Thương mại điện tử trên toàn quốc`;

// get currency
export const getCurrency = (moneyRoyal) => {
	return moneyRoyal.toLocaleString('vi', {
		style    : 'currency',
		currency : 'VND'
	});
};

//range year
export const rangeYear = (minYear, maxYear) => {
	let rY = [];
	for (let i = minYear; i <= maxYear; i++) {
		rY.push(i);
	}
	return rY;
};

//check role
export const getRoleUser = () => {
  const ADMIN_INFO = JSON.parse(localStorage.getItem("_adminInfo"));
  if (ADMIN_INFO) {
    switch (ADMIN_INFO.roles[0]) {
      case "Administrator":
        return 0;
      case "EditorialDirector":
        return 1;
      case "PermanentEditor":
        return 2;
      case "SecretaryEditor":
        return 3;
      case "Editor":
        return 4;
      default:
        return null;
    }
  }
};

export const validateEmail = (email) => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
};

export function getAvatar(img) {
	let url = '';
	const API_URL = `${process.env.REACT_APP_API_URL}`;
	if (!img) {
		return defaultAvt;
	} else {
		let linkClearCache = `${API_URL}${img}?clearcache5=${String(Math.random())}`;
		imageExists(linkClearCache, function(exists) {
			console.log(exists);
			if (exists) {
				return (url = API_URL + img);
			} else {
				return (url = defaultAvt);
			}
		});
	}
	console.log(url);
	return url;
}

const sleep = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};
export const mySleep = () => {
  return sleep(0).then((v) => { });
};

export const handleChangeFile = (files) => {
	if (files.length > 0) {
		if (files[0].size >= 5242880) {
			notifyToast('error', 'Không tải ảnh quá 5MB');
			return false;
		}
	}
};

export const ckeditorConfig = () => {
	const _token = localStorage.getItem('_token');
	return {
		height                   : 500,
		language                 : 'vi',
		extraPlugins             : 'uploadimage,html5video,lineheight,youtube,mathjax,emoji',
		filebrowserUploadUrl     : `${process.env.REACT_APP_API_URL}/api/uploadmedia/upload`,
		fileTools_requestHeaders : {
			'X-Requested-With' : 'XMLHttpRequest',
			Authorization      : 'Bearer ' + _token
		},
		mathJaxLib               :
			'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
		templates_files          : [
			'/assets/js/custom-template.js'
		],
		templates                : 'custom_template'
	};
};

export const ckeditorOnBeforeLoad = (CKEDITOR) => {
	CKEDITOR.plugins.addExternal('html5video', '/admin-portal/assets/js/html5video/', 'plugin.js');
	CKEDITOR.plugins.addExternal('lineheight', '/admin-portal/assets/js/lineheight/', 'plugin.js');
	CKEDITOR.plugins.addExternal('youtube', '/admin-portal/assets/js/youtube/', 'plugin.js');
};

export const deleteImage = async (urlPath, message = 'Xóa ảnh thành công!') => {
	try {
		await apiCaller(`/api/uploadmedia/delete-file?urlPath=${urlPath}`, 'POST');
		notifyToast('success', message);
	} catch (err) {
		// console.log(err.message)
		checkStatusResponse(err.error);
	}
};

export const copyToClipboard = (str) => {
	const el = document.createElement('textarea');
	el.value = str;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
};

// export file xlsx
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const exportAsExcelFile = (worksheet, excelFileName, sheetName) => {
	// const worksheet = xlsx.utils.json_to_sheet(json);
	const workbook = {
		Sheets     : { [`${sheetName}`]: worksheet },
		SheetNames : [
			`${sheetName}`
		]
	};
	const excelBuffer = xlsx.write(workbook, {
		bookType : 'xlsx',
		type     : 'array'
	});
	saveAsExcelFile(excelBuffer, excelFileName);
};

// save as
const saveAsExcelFile = (buffer, fileName) => {
	const data = new Blob(
		[
			buffer
		],
		{
			type : EXCEL_TYPE
		}
	);
	fileSaver.saveAs(data, fileName);
};


export const removeSpecialCharacters = (str) => {
  return str.replace(/[!@^&#,+()$~%.'":*?<>{}]/g, '');
}